// extracted by mini-css-extract-plugin
export default {"priceInfoOverlay__modalContainer":"PriceInfoOverlay__priceInfoOverlay__modalContainer"};